/**
 * OpenUI component name constants (server-safe).
 */

export const LOSI_OPENUI_COMPONENT_NAMES = [
  'Stack',
  'Text',
  'Heading',
  'Metric',
  'Card',
  'ActionButton',
  'TaskViews',
  'TaskCard',
  'NotesBrowser',
  'ContactsPanel',
  'ContactCard',
  'ApprovalCard',
  'BarChart',
  'DataList',
  'StatusBadge',
  'FollowUpBlock',
  'Form',
  'FormControl',
  'Input',
  'Select',
  'SelectItem',
  'SubmitButton'
] as const

export type LosiOpenUIComponentName = (typeof LOSI_OPENUI_COMPONENT_NAMES)[number]
